export default {
  landing: {
    title: "Régie Connect",
    subtitle: "Solution de gestion pour les installateurs multi-services",
    admin: "Administration",
    adminDesc: "Gestion dossiers, stock et régie",
    partner: "Partenaire",
    partnerDesc: "Espace Apporteur",
    installer: "Poseur",
    installerDesc: "Carnet de RDV",
    commercial: "Commercial",
    commercialDesc: "Planning & documents",
    connect: "Connexion",
    welcome: "Bienvenue sur Régie Connect",
  },
  legal: {
    mentions: "Mentions légales",
    cgu: "CGU",
    confidentiality: "Confidentialité",
    back: "Retour",
  },
  paywall: {
    title: "Abonnement requis",
    description: "Votre période d'essai est terminée. Choisissez un plan pour continuer à accéder à votre interface d'administration.",
    choosePlan: "Choisir un plan",
    redirecting: "Redirection…",
    secureNote: "Paiement sécurisé via Stripe. En mode test, utilisez la carte 4242 4242 4242 4242.",
    logout: "Se déconnecter",
  },
  auth: {
    accessAdmin: "Accès Administration",
    accessPartner: "Accès Partenaire",
    accessInstaller: "Accès Poseur",
    accessCommercial: "Accès Commercial",
    createAccount: "Créer un compte",
    emailPlaceholder: "Adresse email",
    passwordPlaceholder: "Mot de passe",
    namePlaceholder: "Nom complet",
    codePlaceholder: "CODE D'ACCÈS",
    login: "Se connecter",
    register: "S'inscrire",
    alreadyHaveAccount: "J'ai déjà un compte",
    createAdminAccount: "Créer un compte administrateur",
    forgotPassword: "Mot de passe oublié ?",
    forgotCode: "Code oublié ?",
    mfaTitle: "Double authentification",
    mfaDescription: "Entrez le code à 6 chiffres de votre application",
    mfaVerify: "Vérifier",
    mfaBack: "Retour",
    secureAccess: "Connexion sécurisée",
    invalidLoginCredentials: "Email ou mot de passe incorrect.",
    invalidLoginCredentialsLocal: "En local : vérifiez que ce compte existe dans votre projet Supabase (Dashboard → Authentication), ou créez un compte avec « Créer un compte administrateur ».",
    invalidRole: "Rôle invalide",
    allFieldsRequired: "Tous les champs sont requis",
    emailPasswordRequired: "Email et mot de passe requis",
    accessCodeRequired: "Code d'accès requis",
    mfaCodeRequired: "Entrez le code à 6 chiffres de votre application",
    forgotPasswordTitle: "Mot de passe oublié ?",
    forgotPasswordDesc: "Entrez votre adresse email pour recevoir un lien de réinitialisation",
    emailRequired: "Adresse email requise",
    sendLink: "Envoyer le lien",
    backToLogin: "Retour à la connexion",
    emailSentTitle: "Email envoyé !",
    resetEmailSentTo: "Un email de réinitialisation a été envoyé à :",
    checkInbox: "Vérifiez votre boîte de réception et cliquez sur le lien pour réinitialiser votre mot de passe.",
    checkSpam: "Pensez à vérifier vos spams si vous ne recevez pas l'email.",
    forgotCodeTitle: "Code oublié ?",
    verification: "Vérification",
    codeRecovered: "Code retrouvé !",
    enterEmail: "Entrez votre adresse email",
    enterCodeReceived: "Entrez le code reçu par email",
    yourAccessCodeDesc: "Voici votre code d'accès",
    sendVerificationCode: "Envoyer le code de vérification",
    verifyCode: "Vérifier le code",
    newCodeSent: "Nouveau code envoyé !",
    noEmailReceived: "Vous n'avez pas reçu l'email ?",
    changeEmail: "Modifier l'email",
    resendCode: "Renvoyer le code",
    verificationSuccess: "Vérification réussie !",
    yourAccessCode: "Votre code d'accès",
    connectNow: "Se connecter maintenant",
    verificationCodeRequired: "Code de vérification requis",
    devEmailNote: "En production, l'email est envoyé via le SMTP Supabase (Resend). En développement, contactez l'administrateur pour obtenir le code.",
    codeSentTo: "Un code de vérification a été envoyé à",
    codeGeneratedFor: "Code généré pour",
    checkSpamFolder: "Pensez à vérifier votre dossier Courrier indésirable si vous ne le recevez pas.",
  },
  access: {
    manageCodesPartners: "Gérer les Codes Partenaires",
    manageCodesInstallers: "Gérer les Codes Poseurs",
    manageCodesCommercials: "Gérer les Codes Commerciaux",
    createAccessCode: "Créer un code d'accès",
    nameOrCompany: "Nom / Société",
    codePlaceholder: "CODE",
    emailRequiredRecovery: "Email (REQUIS pour récupération de code)",
    prefixTip: "Un préfixe unique sera ajouté automatiquement au code",
    emailTip: "L'email est utilisé pour envoyer le code de vérification (gratuit)",
    assignedRegionOptional: "Région assignée (optionnel)",
    noRegion: "Aucune région",
    add: "Ajouter",
    save: "Enregistrer",
    cancel: "Annuler",
    codeLabel: "Code:",
    noEmailImpossible: "Pas d'email (récupération IMPOSSIBLE)",
    edit: "Modifier",
    delete: "Supprimer",
    assignedRegion: "Région assignée",
    seePartnerOnJobs: "Voir le partenaire sur les chantiers",
    partnerManageOwnSchedule: "Gérer ses rendez-vous (dates)",
    partnerManageOwnScheduleTooltip:
      "Si activé, ce partenaire peut définir ou modifier la date et l'heure sur ses propres dossiers en attente ou programmés, et retirer le RDV.",
    disablePartnerTooltip: "Désactiver : ce poseur ne verra plus le partenaire",
    enablePartnerTooltip: "Activer : ce poseur verra le partenaire",
    codeCannotBeModified: "Le code ne peut pas être modifié pour des raisons de sécurité",
    emailRequired: "Email (REQUIS)",
  },
  settings: {
    title: "Compte",
    subtitle: "Profil, sécurité et préférences",
    sectionProfile: "Profil",
    sectionSecurity: "Sécurité",
    sectionCompany: "Entreprise",
    sectionIntegrations: "Intégrations",
    sectionData: "Données",
    sectionNotifications: "Notifications",
    sectionSubscription: "Abonnement",
    sectionDanger: "Supprimer mon compte",
    language: "Langue",
    languageDesc: "Interface en français, anglais ou espagnol",
    profilePhoto: "Photo de profil",
    profilePhotoDesc: "Personnalisez votre avatar",
    change: "Changer",
    remove: "Supprimer",
    security: "Sécurité",
    password: "Mot de passe",
    back: "Retour",
    data: "Données",
    dataDesc: "Import & export CSV ou Excel",
    companyInfo: "Informations entreprise",
    companyInfoDesc: "Devis et factures",
    profilePhotoHint: "JPG, PNG, GIF · 2 Mo max",
    apiKeys: "Clés API",
    apiKeysDesc: "Intégrations et accès REST",
    createKey: "Créer une clé",
    deleteKey: "Supprimer la clé",
    docApi: "Documentation API (OpenAPI)",
    webhooks: "Webhooks",
    webhooksDesc: "Notifications HTTP (dossiers créés, modifiés, terminés)",
    addWebhook: "Ajouter un webhook",
    active: "Actif",
    inactive: "Inactif",
    enable: "Activer",
    disable: "Désactiver",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer",
    passwordUpdated: "Mot de passe mis à jour",
    changePasswordBtn: "Changer le mot de passe",
    changing: "Changement…",
    companyNameLabel: "Nom de la société",
    companySiret: "SIRET",
    companyAddressLabel: "Adresse",
    companyPhoneLabel: "Téléphone",
    invoiceTemplateSection: "Devis & factures",
    invoiceTemplateDesc: "Personnalisez l’apparence de vos devis et factures PDF.",
    myQuotes: "Mes devis",
    myInvoices: "Mes factures",
    matchWithQuote: "Reprendre un devis",
    matchWithQuoteHint: "Choisir un dossier pour reprendre le client et le montant du devis.",
    invoiceTemplateTheme: "Thème",
    invoiceTheme_minimal: "Minimal",
    invoiceTheme_minimal_desc: "Épuré, lignes fines, beaucoup d’espace.",
    invoiceTheme_classic: "Classique",
    invoiceTheme_classic_desc: "Bordures discrètes, équilibré.",
    invoiceTheme_luxe: "Luxe",
    invoiceTheme_luxe_desc: "Accent marqué, barre de titre, premium.",
    invoiceTemplateAccentColor: "Couleur d’accent",
    invoiceTemplateFooter: "Pied de page personnalisé",
    invoiceTemplateFooterPlaceholder: "Laissez vide pour le texte par défaut. Ex. : Mentions légales, conditions de paiement…",
    invoiceTemplateScripts: "Scripts et textes",
    invoiceTemplateIntroText: "Texte d’introduction",
    invoiceTemplateIntroPlaceholder: "Texte affiché en haut du document (avant Client / Date). Ex. : Objet de la prestation…",
    invoiceTemplateTermsText: "Conditions / mentions",
    invoiceTemplateTermsPlaceholder: "Conditions générales, délai de paiement, pénalités… (affiché après le total).",
    invoiceTemplateLayout: "Mise en page",
    invoiceTemplatePageOrientation: "Orientation de la page",
    invoiceOrientation_portrait: "Portrait",
    invoiceOrientation_landscape: "Paysage",
    invoiceTemplateFontSize: "Taille du texte",
    invoiceFontSize_small: "Petit",
    invoiceFontSize_normal: "Normal",
    invoiceFontSize_large: "Grand",
    invoiceTemplateLogoPosition: "Position du logo",
    invoiceLogoPosition_left: "Gauche",
    invoiceLogoPosition_right: "Droite",
    invoiceTemplateLogoUrl: "URL du logo (optionnel)",
    invoiceTemplateLogoHint: "URL publique d’une image (PNG ou JPG). Affichée en en-tête du document.",
    invoiceTemplatePreview: "Aperçu",
    invoicePreviewCompany: "Ma Société",
    invoiceTemplateAppearance: "Apparence",
    invoiceTemplateLogo: "Logo sur le document",
    invoiceTemplateUseProfilePhoto: "Utiliser ma photo de profil comme logo",
    invoiceTemplateLogoOrDrop: "Ou déposez une image ci‑dessous (glisser-déposer) ou collez une URL.",
    invoiceTemplateDropLogo: "Glisser-déposer un logo ou cliquer pour choisir",
    saved: "Enregistré",
    saving: "Enregistrement…",
    saveBtn: "Enregistrer",
    exportData: "Export de vos données",
    exportDataDesc: "Droit à la portabilité (RGPD) · ZIP avec dossiers, stock, logs, etc.",
    downloadAll: "Télécharger tout",
    generating: "Génération…",
    exportJobs: "Exporter les dossiers",
    importJobs: "Importer des dossiers",
    importJobsHint: "Fichier .xlsx, .xls ou .csv",
    chooseFile: "Choisir un fichier",
    download: "Télécharger",
    notifications: "Notifications",
    notificationsDesc: "Activer ou désactiver les alertes",
    globalAlert: "Alerte globale",
    globalAlertDesc: "Recevoir les notifications dans l'app (pas d'email)",
    newJobsNotif: "Nouveaux dossiers",
    newJobsNotifDesc: "Être notifié",
    miniSecretary: "Mini secrétaire",
    miniSecretaryDesc: "Bulle de notification à l'entrée sur le CRM",
    mySubscription: "Mon abonnement",
    billingPlan: "Facturation et plan",
    currentStatus: "Statut actuel",
    manageSubscription: "Gérer l'abonnement",
    security2FA: "Sécurité",
    security2FADesc: "Vérification en deux étapes",
    scanQR: "Scannez ce QR code avec votre application (Google Authenticator, Authy, etc.) puis entrez le code à 6 chiffres.",
    enterCode6: "Code à 6 chiffres",
    cancel: "Annuler",
    validate: "Valider",
    verifying: "Vérification…",
    disable2FA: "Désactiver la vérification en deux étapes",
    enable2FA: "Activer la vérification en deux étapes",
    preparing: "Préparation…",
    dangerZone: "Zone de danger",
    dangerZoneDesc: "Supprimer définitivement le compte et toutes les données",
    deleteAccountWarn: "Cette action supprime tout : dossiers, partenaires, poseurs, stock, régions, historique, abonnement et votre compte. Elle est irréversible.",
    deleteAccountBtn: "Supprimer mon compte",
    deleteAccountModalTitle: "Supprimer définitivement le compte",
    deleteAccountModalDesc: "Saisissez SUPPRIMER pour confirmer. Toutes les données seront supprimées.",
    deleteConfirmPlaceholder: "SUPPRIMER",
    deleting: "Suppression…",
    deletePermanently: "Supprimer définitivement",
    newApiKey: "Nouvelle clé API",
    keyNameOptional: "Nom (optionnel)",
    keyNamePlaceholder: "Ex. Intégration CRM",
    create: "Créer",
    keyCreated: "Clé créée",
    keySaveNotice: "Conservez cette clé : elle ne sera plus affichée.",
    copy: "Copier",
    close: "Fermer",
    newWebhook: "Nouveau webhook",
    webhookUrlLabel: "URL de réception",
    webhookUrlPlaceholder: "https://votre-serveur.com/webhook",
    webhookEventsLabel: "Événements",
    webhookEventsHint: "Si aucun n'est coché, tous seront envoyés.",
    webhookSecret: "Secret du webhook",
    webhookSecretNotice: "Utilisez ce secret pour vérifier la signature (X-Webhook-Signature). Il ne sera plus affiché.",
    jobCreated: "Dossier créé",
    jobUpdated: "Dossier modifié",
    jobCompleted: "Dossier terminé",
    sessionExpired: "Session expirée. Reconnectez-vous.",
    createKeyError: "Erreur lors de la création",
    urlMustStart: "L'URL doit commencer par https:// ou http://",
    passwordMinLength: "Le mot de passe doit faire au moins 6 caractères",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    mfaScanSecret: "Ou entrez ce secret manuellement :",
    mfaInvalidCode: "Code invalide",
    mfaEnrollError: "Erreur activation 2FA",
    mfaUnenrollError: "Erreur désactivation 2FA",
    mfaEnterCode6: "Entrez le code à 6 chiffres",
    mfaChallengeFail: "Échec du défi",
    planTrialing: "Essai gratuit",
    planActive: "Pro",
    planPastDue: "Paiement en retard",
    planCanceled: "Résilié",
    planIncomplete: "Incomplet",
    csvClient: "Client",
    csvPhone: "Téléphone",
    csvAddress: "Adresse",
    csvStatus: "Statut",
    csvDate: "Date",
    csvTime: "Heure",
    csvSurface: "Surface",
    csvLightingType: "Type d'éclairage",
    csvCeilingHeight: "Hauteur plafond",
    csvNotes: "Notes",
    csvCreatedAt: "Date de création",
    statusPending: "En attente",
    statusScheduled: "Planifié",
    statusInProgress: "En cours",
    statusCompleted: "Terminé",
    statusCanceled: "Annulé",
    noValidRows: "Aucune ligne valide (Client ou Adresse requis).",
  },
  admin: {
    settings: "Compte",
    home: "Accueil",
    overview: "Vue d'ensemble",
    jobs: "Dossiers",
    stock: "Stock",
    team: "Équipe",
    planning: "Planning",
    regions: "Régions",
    partners: "Partenaires",
    installers: "Poseurs",
    budget: "Budget",
    access: "Accès",
    workSection: "Travail",
    organizationSection: "Organisation",
    logout: "Déconnexion",
    // Contenu des pages
    overviewCompleted: "Terminés",
    overviewPending: "En attente",
    overviewTitle: "Tableau de bord",
    overviewSubtitle: "Accès rapide à ce qui compte aujourd’hui.",
    overviewToSchedule: "À programmer",
    overviewToScheduleHint: "En attente ou planifiés",
    overviewInProgressHint: "Chantiers démarrés",
    overviewDoneHint: "Clôturés ou annulés",
    overviewPlanningHint: "Calendrier & RDV",
    overviewLowStock: "Stock bas",
    overviewLowStockHint: "référence(s) sous seuil",
    overviewLowStockOk: "Aucune alerte",
    overviewRecentActivity: "Activité récente",
    overviewClear: "Effacer",
    overviewNoAccess:
      "Vous n'avez accès à aucune section sur cette page. Utilisez le menu selon vos droits.",
    jobsHubHint: "Choisissez une catégorie pour continuer.",
    statusPending: "En attente",
    statusScheduled: "Planifié",
    statusInProgress: "En cours",
    statusCompleted: "Terminé",
    statusCancelled: "Annulé",
    jobsInProgress: "Chantiers en cours",
    noJobsInProgress: "Aucun chantier en cours",
    client: "Client",
    address: "Adresse",
    phone: "Téléphone",
    region: "Région",
    installer: "Poseur",
    dateCreated: "Date création",
    invoice: "Facture (€)",
    newJob: "Nouveau dossier",
    newShort: "Nouveau",
    add: "Ajouter",
    addRegion: "Ajouter une région",
    addPartner: "Ajouter un partenaire",
    newPartner: "Nouveau partenaire",
    cancel: "Annuler",
    save: "Enregistrer",
    edit: "Modifier",
    delete: "Supprimer",
    budgetPartners: "Budget partenaires",
    seeDetail: "Voir le détail",
    noInvoiceYet: "Aucune facture pour l'instant",
    jobsInvoiced: "chantier(s) facturé(s)",
    budgetJobsLine: "{{count}} chantier(s) facturé(s)",
    monthlyEvolution: "Évolution mensuelle (budget)",
    revenueTitle: "Revenus & CA",
    caTotal: "CA total",
    caThisMonth: "CA du mois",
    avgTicket: "Panier moyen",
    invoicesCount: "Factures",
    trendLabel: "Tendance vs mois préc.",
    caChartHint: "CA facturé partenaires (12 mois). Le bénéfice net nécessite des coûts d’achat non suivis ici.",
    stockByPartnerRegion: "Stock par partenaire et par région",
    stockDescription: "Le stock est géré par partenaire et par région. Choisissez ci-dessous pour afficher ou modifier les quantités.",
    stockOf: "Stock de",
    reference: "Référence",
    quantity: "Quantité",
    installersInRegion: "Poseurs de la région",
    installersByRegion: "Poseurs par région. Cliquez sur une région pour tout voir.",
    regionLabel: "Région",
    installerLabel: "Poseur",
    noRegion: "Sans région",
    unassigned: "Non assigné",
    searchPlaceholder: "Client, adresse, tél, poseur…",
    statusLabel: "Statut",
    typeLabel: "Type",
    filterStatus: "Statut :",
    filterRegion: "Région :",
    filterInstaller: "Poseur :",
    deleteRegionConfirm: "Supprimer la région « {{name}} » ? Le stock de cette région sera aussi supprimé.",
    editRegion: "Modifier la région",
    deleteRegion: "Supprimer la région",
    editPartners: "Modifier les partenaires",
    allRegions: "Toutes les régions",
    allPartners: "Tous les partenaires",
    allInstallers: "Tous les poseurs",
    allStatuses: "Tous statuts",
    allRegionsShort: "Toutes régions",
    filterPlanning: "Filtrer le planning",
    partnerLabel: "Partenaire",
    sortLabel: "Trier :",
    dateShort: "Date",
    searchLabel: "Recherche :",
    noRegionYet: "Aucune région",
    addRegionsToSee: "Ajoutez des régions pour afficher les poseurs par région.",
    byRegion: "Par région",
    summaryOf: "Synthèse des {{count}} dossier(s) affichés (filtres et vue courants).",
    jobSingular: "dossier",
    jobPlural: "dossiers",
    jobCount: "dossier(s)",
    noInvoiceInRegion: "Aucune facture pour l'instant (dossiers terminés et facturés apparaîtront ici).",
    regionDetailDesc: "Détail de la région : stocks, poseurs, partenaires, dossiers et factures.",
    regionChooseDesc: "Choisissez une région pour voir tout le détail (stocks, poseurs, partenaires, dossiers, factures).",
    stockByRegionDesc: "Stock par région. Cliquez sur une région pour tout voir.",
    jobsTabLabel: "Dossiers",
    stocksTabLabel: "Stocks",
    installerCount: "poseur(s)",
    jobCountShort: "chantier(s)",
    newJobTitle: "Nouveau dossier (Admin)",
    assignInstaller: "Assigner un Poseur",
    assignCommercial: "Assigner un Commercial",
    assignToNobody: "Désassigner",
    chooseOption: "— Choisir —",
    fullAddressPlaceholder: "Adresse complète",
    clientNamePlaceholder: "Nom du client",
    clientPhonePlaceholder: "Numéro du client",
    stockRegionNote: "Région du poseur assigné.",
    stockRegionHouseLabel: "Région (maison de stock)",
    mainRegionLabel: "Région principale",
    stockRegionsTitle: "Régions de stock",
    // Boutons et sous-titres
    actions: "Actions",
    allFolder: "Tous",
    folderAdmin: "Admin",
    allJobsFolder: "Tous les dossiers",
    adminAndTeam: "Admin & Équipe",
    adjustStock: "Ajuster le stock",
    clearLabel: "Effacer",
    importButton: "Importer",
    importLoading: "Import…",
    listView: "Liste",
    summaryView: "Résumé",
    budgetOverviewTab: "Vue d'ensemble",
    budgetTariffsTab: "Tarifs",
    budgetInvoicesTab: "Factures",
    totalInvoiced: "Total facturé",
    invoicesInRegion: "Factures de la région",
    partnersInRegion: "Partenaires de la région",
    editTariff: "Modifier un tarif",
    budgetIntro: "Les montants des factures partenaires sont calculés à partir des tarifs par partenaire, région et type de dossier (onglet Tarifs). Consultez l'onglet Factures pour le détail par partenaire et par dossier.",
    editReference: "Modifier la référence",
    editJob: "Modifier le dossier",
    viewJob: "Consulter le dossier",
    viewOnlyNoEdit: "Consultation seule — vous n'avez pas le droit de modifier ce dossier",
    openDossier: "Ouvrir le dossier",
    editReport: "Modifier le rapport",
    closeJob: "Clôturer le chantier",
    addStockUnit: "Ajouter une unité",
    manageInstallers: "Modifier les poseurs",
    statusCancelledClient: "Annulé (client)",
    deleteRegionShortConfirm: "Supprimer cette région ? Le stock associé sera aussi supprimé.",
    editOrDeleteRegion: "Modifier ou supprimer cette région",
    history: "Historique",
    jobsInvoicedCount: "Chantiers facturés",
    recalculateInvoices: "Recalculer les factures",
    recalculateLoading: "Recalcul…",
    tariffGrid: "Grille tarifaire",
    // Modales et messages
    regieAdmin: "Régie Admin",
    loading: "Chargement…",
    internalStock: "Stock interne",
    noRecentActivity: "Aucune activité récente.",
    partnerPlaceholder: "Partenaire…",
    perPage: "Par page",
    goTo: "Aller à",
    noJobs: "Aucun dossier",
    noInstallerInRegion: "Aucun poseur assigné dans cette région.",
    newRegion: "Nouvelle région",
    addRegionShort: "Ajouter une région",
    noRegionHere: "Aucune région",
    alertLabel: "Alerte",
    noStockInRegion: "Aucun article en stock dans cette région.",
    noInstallerWithJobInRegion: "Aucun poseur avec chantier dans cette région.",
    amount: "Montant",
    partnersTitle: "Partenaires",
    choosePartnerDesc: "Choisissez un partenaire pour voir ses chantiers par région.",
    chooseInstallerDesc: "Cliquez sur un poseur pour voir tous ses dossiers assignés.",
    noPartnerInRegion: "Aucun partenaire avec dossier dans cette région.",
    noInstallerHere: "Aucun poseur",
    addInstallersInAccess: "Ajoutez des poseurs dans Gestion Accès.",
    allInstallersTitle: "Tous les poseurs",
    loadingTariffs: "Chargement des tarifs…",
    chooseRegionOption: "Choisir une région",
    newPrice: "Neuf (€)",
    replacementPrice: "Remplacement (€)",
    chooseReferenceOption: "Choisir une référence",
    newLabel: "Neuf",
    replacementLabel: "Remplacement",
    unitPrice: "Prix unitaire (€)",
    byPartner: "Par partenaire",
    totalInvoicesByPartner: "Total des factures (dossiers terminés) par partenaire.",
    invoiceDetail: "Détail des factures",
    noJobWithPartner: "Aucun dossier terminé avec partenaire.",
    seeStockOf: "Voir le stock de :",
    choosePartnerOption: "Choisir un partenaire…",
    noReferenceForPartner: "Aucune référence pour ce partenaire.",
    nameQtyAlert: "Nom, quantité et seuil d'alerte.",
    detailsAndPlanning: "Détails et planification",
    jobTypeLabel: "Type de dossier",
    led: "LED",
    dehumidifier: "Déshumidificateur",
    nameOrFirstName: "Nom / Prénom",
    jobCancelledByClient: "Dossier annulé par le client.",
    technicalVisit: "Visite technique",
    installation: "Pose",
    quantitiesPlaced: "Quantités posées (neuf / remplacement) et commentaire",
    createJobDesc: "Créer un dossier et optionnellement l'assigner à une équipe",
    contextStockUsed: "Contexte : stock utilisé",
    businessBringer: "Apporteur d'affaires",
    noPartnerInternal: "Sans partenaire (stock interne)",
    chooseRegionDot: "Choisir une région...",
    clientAndTech: "Client & technique",
    typeDot: "Type...",
    notesLabel: "Notes",
    chooseTeam: "Choisir une équipe...",
    chooseJobTypeAlert: "Veuillez choisir le type de dossier (LED extérieur, LED intérieur, Déshumidificateur, VMC Agricoles, TH 122, Rénovation, HP/BP flottante ou PAC).",
    errorAiSearch: "Erreur recherche IA",
    errorAiSuggest: "Erreur suggestion IA",
    errorAiStock: "Erreur suggestion stock",
    noItemInRegion: "Aucun article dans cette région",
    noValidRowImport: "Aucune ligne valide (Client ou Adresse requis).",
    errorImport: "Erreur lors de l'import.",
    readFileError: "Lecture du fichier impossible",
    invoiceLabel: "Facture :",
    partnerInvoiceLabel: "Facture partenaire :",
  },
  partner: {
    deleteJob: "Supprimer le dossier",
    deleteJobConfirm: "Supprimer ce dossier ? Cette action est irréversible.",
    deleteJobError: "Impossible de supprimer le dossier.",
  },
  installer: {
    history: "Historique",
    myDay: "Ma journée",
    myDossiers: "Mes dossiers",
    nothingToday: "Rien de prévu aujourd'hui",
    jobs: "Dossiers",
    planning: "Planning",
    menu: "Menu",
    close: "Fermer",
    spaceTitle: "Espace Poseur",
    date: "Date",
    time: "Heure",
    appointmentDate: "Date du RDV",
    appointmentTime: "Heure du RDV",
    tapToEdit: "Appuyer pour modifier",
    imGoing: "J'Y VAIS",
    call: "APPELER",
    noPhone: "Numéro non renseigné",
    materialUsed: "Matériel utilisé ?",
    new: "Neuf",
    replacement: "Remplacement",
    validationSuccess: "Dossier validé.",
    validationInHistory: "Il est désormais dans votre historique.",
    jobsInProgress: "Chantiers en cours",
    noJobsInProgress: "Aucun chantier en cours",
    viewOnlyInProgress: "En cours — consultation seule",
  },
  signedQuote: {
    title: "Documents",
    loading: "Chargement du fichier…",
    loadError: "Impossible d'afficher le document. Reconnectez-vous ou contactez l'administrateur.",
    invalidPath: "Chemin du fichier invalide.",
    previewAlt: "Aperçu du document",
    openPdf: "Ouvrir le PDF",
    openImage: "Ouvrir l'image",
    delete: "Supprimer",
    deleteConfirm: "Supprimer ce document ? Cette action est irréversible.",
    deleteError: "Impossible de supprimer le fichier.",
    fileTypesHint: "PDF ou photo (JPEG, PNG, WebP) — max. {{maxMb}} Mo par fichier",
    tapToUpload: "Appuyer pour ajouter photo(s) ou PDF",
    uploading: "Envoi en cours…",
    replaceFile: "Remplacer le fichier existant (optionnel)",
    addMore: "Ajouter un document",
    addMoreHint: "Vous pouvez ajouter plusieurs fichiers",
    uploadSuccess: "Document enregistré avec succès",
  },
  commercial: {
    appTitle: "Espace Commercial",
    planningOnly: "Planning",
    logout: "Déconnexion",
    noAppointments: "Aucun rendez-vous planifié",
    noAppointmentsHint: "Votre administrateur doit vous assigner des dossiers avec une date.",
    backToPlanning: "Retour au planning",
    appointment: "Rendez-vous",
    date: "Date",
    time: "Heure",
    openMaps: "Google Maps",
    address: "Adresse",
    partnerRemarks: "Remarques du partenaire (dossier)",
  },
  common: {
    settings: "Compte",
    logout: "Déconnexion",
    appearance: "Apparence",
    themeSystem: "Appareil",
    themeLight: "Clair",
    themeDark: "Sombre",
    roleOwner: "Propriétaire",
    roleAdmin: "Administrateur",
    rolePartner: "Partenaire",
    roleInstaller: "Installateur",
    roleCommercial: "Commercial",
    langFr: "Français",
    langEn: "English",
    langEs: "Español",
  },
} as const;
